import React from 'react';
import './App.css';
import Header from './components/header/Header';
import ServiceGallery from './components/servicegallery/ServiceGallery';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import ScrollUp from './components/scrollup/ScrollUp';
import Social from './components/social/Social';
import Services from './components/services/Services';
import Testimonials from './components/testimonial/Testimonials';
import Business from './components/business/Business';
import InstagramFeed from './components/instagram/instaposts';
import BlobAnimation from './components/blob/bloblanimation';


function App() {
  return (
    <>
    <div className='website__background__header'>
     <Header />
     <About />
     </div>
     <main className='main'>
      <Business/>
      <div className='services__background'>
      <Services/>
      <ServiceGallery />
      </div>
      <div className='instagram__background'>
      <InstagramFeed/>
      </div>
      <div className='contact__background'>
      <Contact/>
      </div>
      <Testimonials/>
     </main>
     <Social/>
     <Footer/>
     {/*  <ScrollUp/>*/}

    </>
  );
}

export default App;
